import {AccessoryModel, accessoryModelFactory} from "./accessory.model";

export interface SelectableAccessoryModel extends AccessoryModel {
  selected?: boolean;
  entity?: string;
}

export function selectableAccessoryModelFactory(json?: any): SelectableAccessoryModel {
  const model = accessoryModelFactory(json) as SelectableAccessoryModel;
  model.selected = !!json.selected;
  model.entity = json.entity || "";

  return model;
}

export function selectableAccessoryModelListFactory(json?: any): SelectableAccessoryModel[] {
  return Array.from(json || []).map(it => selectableAccessoryModelFactory(it)) as SelectableAccessoryModel[];
}
